import React, { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import Spinner from "../ogComponent/spinner";
import Table from "../ogComponent/table";
import { Select, MenuItem, FormControl, Modal, Box } from "@mui/material";
import CustomModal from "../ogComponent/modal";
import { Toast } from 'primereact/toast';
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import { IconEdit, IconTrash } from "@tabler/icons-react";

export default function BranchDetails() {
  const toast = useRef(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const [branch, setBranch] = useState();
  const [loading, setLoading] = useState(true);
  const [selectedDepartment, setSelectedDepartment] = useState("All Departments");
  const [filteredEmployees, setFilteredEmployees] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [showEditModal, setShowEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  // Access permissions array from Redux store
  const permissions = useSelector((state) => state.emp.permissions);

  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    maxWidth: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    outline: "none",
    borderRadius: '10px',
  };

  const header = [
    { name: "Si No", label: "#", active: true },
    { name: "name", label: "Name", active: true },
    { name: "job_position", label: "Job Position", active: true },
    { name: "contact_info", label: "Contact Info", active: true },
    { name: "Status", label: "Active", active: true },
  ];

  const pagePermissions = ["editbranchesID", "deletebranchesID", "employeedetailsID"];

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  useEffect(() => {
    const fetchDepartments = async () => {
      const token = localStorage.getItem("accessToken");
      try {
        const response = await axios.get(`${process.env.REACT_APP_API}/api/employee/departments/?branches=${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
        setDepartments(response.data);
      } catch (error) {
        console.error("Error fetching departments:", error);
      }
    };

    if (id) {
      fetchDepartments();
    }
  }, [id]);

  const handleDeleteClick = () => {
    if (branch.employee_count > 0) {
      toast.current.show({
        severity: 'warn',
        summary: 'Cannot Delete Branch',
        detail: "This branch contains employees. Please remove employees before deleting.",
        life: 3000,
      });
    } else {
      setOpenDeleteModal(true);
    }
  };

  const handleCloseDeleteModal = () => {
    setOpenDeleteModal(false);
  };

  const handleConfirmDelete = async () => {
    const token = localStorage.getItem("accessToken");
    try {
      await axios.delete(
        `${process.env.REACT_APP_API}/api/employee/branches/${id}/`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setOpenDeleteModal(false);
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: "Branch Deleted Successfully",
        life: 3000,
      });
      setTimeout(() => {
        navigate('/user/branchs/');
      }, 3000);
    } catch (error) {
      console.error("Error deleting branch:", error);
    }
  };

  const handleEditClick = () => {
    console.log("current branch is,", branch);
    setShowEditModal(true);
  };

  const handleModalClose = () => {
    setShowEditModal(false);
  };

  const formatText = (text) => {
    return text ? text.charAt(0).toUpperCase() + text.slice(1) : "";
  };

  const handleEditSubmit = async (data) => {
    const token = localStorage.getItem("accessToken");
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_API}/api/employee/branches/${id}/`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setBranch(response.data);
      setShowEditModal(false);
      toast.current.show({
        severity: 'success',
        summary: 'Success',
        detail: "Branch Updated Successfully",
        life: 3000,
      });
    } catch (error) {
      console.error("Error updating branch details:", error);
      toast.current.show({
        severity: 'Error',
        summary: 'Error',
        detail: "Branch Updation Failed",
        life: 3000,
      });
    }
  };

  const editModalFields = [
    {
      name: "branch_name",
      label: "Branch Name",
      type: "text",
      value: formatText(branch?.branch_name),
      required: true,
    },
    {
      name: "branch_head",
      label: "Branch Head",
      type: "text",
      value: formatText(branch?.branch_head),
      required: true,
    },
    {
      name: "location",
      label: "Location",
      type: "text",
      value: formatText(branch?.location),
      required: true,
    },
    {
      name: "contact_info",
      label: "Contact Info",
      type: "text",
      value: branch?.contact_info,
      required: true,
    },
  ];

  const handleRowClick = permissions.includes("employeedetailsID")
    ? (item) => navigate(`/user/empdetails/${item.id}`)
    : undefined;

  useEffect(() => {
    const fetchBranchDetails = async () => {
      const token = localStorage.getItem("accessToken");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/employee/branches/${id}/`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setBranch(response.data);
      } catch (error) {
        console.error("Error fetching branch details:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchBranchDetails();
  }, [id]);

  useEffect(() => {
    const fetchEmployees = async () => {
      const token = localStorage.getItem("accessToken");
      setLoading(true);
      try {
        const departmentParam =
          selectedDepartment !== "All Departments"
            ? `&department=${selectedDepartment}`
            : "";
        const response = await axios.get(
          `${process.env.REACT_APP_API}/api/account/users-list/?branch=${id}${departmentParam}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFilteredEmployees(response.data || []);
      } catch (error) {
        console.error("Error fetching employees:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEmployees();
  }, [id, selectedDepartment]);

  const transformEmployeeData = (employees) => {
    return employees.map((employee, index) => ({
      id: employee.id,
      "Si No": index + 1,
      name: (
        <td
          className="d-flex gap-3 align-items-center px-0"
          style={{
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          <img
            style={{
              width: "25px",
              height: "25px",
              flexShrink: 0,
              borderRadius: "50%",
            }}
            src={
              employee.profile_photo
                ? employee.profile_photo
                : "/assets/user.png"
            }
            alt="user img"
          />
          <div style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
            {employee.name || "N/A"}
          </div>
        </td>
      ),
      job_position: employee.job_position?.job_title || "N/A",
      contact_info: employee.phone_number || "N/A",
      Status: (
        <div style={{ color: employee.status ? "green" : "tomato" }}>
          <span
            style={{
              display: "inline-block",
              width: "7px",
              height: "7px",
              borderRadius: "50%",
              backgroundColor: employee.status ? "green" : "tomato",
              marginRight: "5px",
            }}
          ></span>
          {employee.status ? "Active" : "Inactive"}
        </div>
      ),
    }));
  };

  const handleDepartmentChange = (event) => {
    setSelectedDepartment(event.target.value);
  };

  if (loading) {
    return <Spinner />;
  }

  return (
    <>
      <style>
        {`
      @media (max-width: 500px) {
        .modalmainbox {
          minWidth: 75% !important;
        }
      }
    `}
      </style>
      <div className="singleBranchContainer px-md-5 px-3 pt-4 w-100">
        <Toast ref={toast} position="bottom-right" />
        {branch ? (
          <>
            <h4>
              {branch.branch_name} - {branch.location}
            </h4>
            <table>
              <tr>
                <td className="ps-0">Branch Head:</td>
                <td>{branch.branch_head}</td>
              </tr>
              <tr>
                <td className="ps-0">Contact Info:</td>
                <td>{branch.contact_info}</td>
              </tr>
              <tr>
                <td className="ps-0">Employees:</td>
                <td>{branch.employee_count}</td>
              </tr>
            </table>

            <div className="employeeTableContainer w-100">
              <div className="d-flex justify-content-end mb-3 gap-2 gap-md-3">
                <FormControl variant="outlined" style={{ minWidth: 200 }}>
                  <Select
                    value={selectedDepartment}
                    onChange={handleDepartmentChange}
                    displayEmpty
                    inputProps={{ "aria-label": "Without label" }}
                  >
                    <MenuItem value="All Departments">All Departments</MenuItem>
                    {departments.map((dept) => (
                      <MenuItem key={dept.id} value={dept.id}>
                        {dept.dep_name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {permissions.includes("editbranchesID") && (
                  <button
                    className="btn btn-outline-primary"
                    onClick={handleEditClick}
                    data-bs-toggle="modal"
                    data-bs-target="#staticBackdrop"
                  >
                    <IconEdit stroke={2} />
                  </button>
                )}
                {permissions.includes("deletebranchesID") && (
                  <button className="btn btn-outline-danger" onClick={handleDeleteClick}>
                    <IconTrash stroke={2} />
                  </button>
                )}
              </div>
              {filteredEmployees.length > 0 ? (
                <Table
                  header={header}
                  product={transformEmployeeData(filteredEmployees)}
                  onRowClick={handleRowClick}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              ) : (
                <div className="d-flex justify-content-center align-items-end position-relative" style={{ height: "50vh" }}>
                  <div className="position-absolute top-0 start-0 w-100 h-100" style={{
                    backgroundImage: 'url(/assets/file.png)',
                    backgroundSize: 'contain',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    opacity: 0.3,
                  }}></div>
                  <p className="m-0 fw-light fs-5 position-relative">No Employees Found!</p>
                </div>
              )}
            </div>
          </>
        ) : (
          <p>Branch not found.</p>
        )}
        {permissions.includes("editbranchesID") && (
          <CustomModal
            heading="Edit Branch Data"
            fields={editModalFields}
            onSubmit={handleEditSubmit}
            type={""}
          />
        )}
        <Modal
          open={openDeleteModal}
          onClose={handleCloseDeleteModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          style={{ outline: "none" }}
        >
          <Box
            sx={{ ...modalStyle, outline: "none", padding: "25px" }}
            className="modalmainbox"
          >
            <div className="w-100 d-flex align-items-center flex-column">
              <WarningAmberIcon
                sx={{ color: "#FFA000", fontSize: 60, width: "100%" }}
              />
              <Box
                sx={{
                  fontWeight: "bold",
                  fontSize: "clamp(13px, 1.4vw, 17px)",
                  mb: 2,
                }}
              >
                Confirm Delete
              </Box>
              <Box
                sx={{
                  color: "#555",
                  mb: 2,
                  fontSize: "clamp(12px, 1.2vw, 14px)",
                  textWrap: "wrap",
                  textAlign: "center",
                  paddingX: "10px",
                }}
              >
                Are you sure want to delete this branch?
              </Box>
            </div>
            <div className="w-100 d-flex justify-content-between flex-row-reverse gap-3">
              <button
                className="btn btn-danger"
                onClick={handleConfirmDelete}
                style={{ fontSize: "clamp(12px, 1.2vw, 15px)" }}
              >
                Confirm
              </button>
              <button
                className="btn btn-secondary"
                onClick={handleCloseDeleteModal}
                style={{ fontSize: "clamp(12px, 1.2vw, 15px)" }}
              >
                Cancel
              </button>
            </div>
          </Box>
        </Modal>
      </div>
    </>
  );
}